import type { Palette } from "@mui/material";
import type { CalculatorArea } from "web_myplann/Calculators/Types/CalculatorArea";
import type { PortfolioAreaColor } from "web_myplann/Infrastructure/Themes/Colors";

export const getCalculatorAreaColor = (
	palette: Pick<Palette, "portfolioArea" | "goalArea">,
	area: CalculatorArea,
): PortfolioAreaColor =>
	area === "goals" ? palette.goalArea : palette.portfolioArea[area];
